import { cn } from "@/ds/utils";
import type { FC, PropsWithChildren } from "react";

export interface StatisticsBarProps extends PropsWithChildren {
	className?: string;
}

export const StatisticsBar: FC<StatisticsBarProps> = props => {
	const {
		className,
		children
	} = props;

	return (
		<div className={cn("grid grid-cols-[repeat(auto-fit,minmax(140px,1fr))] gap-4 border-b p-3", className)}>
			{children}
		</div>
	);
};

export interface StatisticProps extends PropsWithChildren {
	title: string;
	className?: string;
}

export const Statistic: FC<StatisticProps> = props => {
	const {
		title,
		className,
		children
	} = props;

	return (
		<div className="flex flex-col gap-1">
			<div className={className}>{children}</div>
			<div className="type-overline whitespace-nowrap">{title}</div>
		</div>
	);
};
